package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Assistant_message(
  public val id: String,
  public val conversation_id: String,
  public val role: String,
  public val content: String,
  public val sources: String?,
  public val status: String,
  public val error_code: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
